export enum MessageType {
    Telemetry = 'Telemetry',
    DTC = 'DTC',
    Everything = 'data'
}
